import * as React from 'react'
import './App.css'
import Editor from './components/Editor/Editor'
import { Header } from './components/Header/Header'
import { Login } from './components/Login/Login'
import { Settings } from './components/SettingsPanel/Settings'
import Model, { UserData, DefaultUserData } from './model/Model'
import { TopMenuItem } from './navigation'
import { MetadataPage } from './components/Metadata/MetadataPage'
import { isLoggedIn, isReviewer, setTokens } from './servicesClient'

export interface AppProps {
  appModel: Model;
}

export interface AppState {
  menuItem: TopMenuItem;
  inited: boolean;
  initFailed: boolean;
  logged: boolean;
  userData: UserData;
}

export default class App extends React.Component<AppProps, AppState> {
  state = {
    menuItem: getInitialMenuItem(),
    inited: false,
    initFailed: false,
    logged: isLoggedIn(),
    userData: DefaultUserData
  };

  render () {
    const { menuItem } = this.state
    const { appModel } = this.props

    const renderScreen = () => {
      switch (menuItem) {
        case TopMenuItem.Tool:
          return <Editor appModel={appModel} userData={this.state.userData} />
        case TopMenuItem.Settings:
          return <Settings appModel={appModel} />
        case TopMenuItem.Metadata:
          return <MetadataPage />
        case TopMenuItem.Login:
          return <Login login={this.login} />
      }
      return null
    }

    if (!this.state.inited) {
      return 'Loading...'
    }
    if (this.state.initFailed) {
      return 'Cannot connect to backend services'
    }

    return (
      <div className="App">
        <Header menuItem={menuItem} selectMenuItem={this.selectMenuItem} />

        {renderScreen()}
      </div>
    )
  }

  async componentWillMount () {
    let userData: UserData = DefaultUserData
    try {
      if (this.state.logged) {
        // getUserData() has to happen after initRpcClient()
        userData = await this.props.appModel.getUserData()
      }
    } catch (e) {
      console.log(e)
      this.setState({ initFailed: true })
    } finally {
      this.setState({ inited: true, userData: userData })
    }
  }

  selectMenuItem = async (menuItem) => {
    if (menuItem === TopMenuItem.Logout) {
      await setTokens(null)
      this.setState({ logged: false, menuItem: TopMenuItem.Login })
      return
    }

    this.setState({ menuItem })
  };

  login = async (tokens) => {
    await setTokens(tokens)
    // do this here to ensure tha userData is up-to-date for the Editor component
    const userData: UserData = await this.props.appModel.getUserData()
    // TODO: remove this log
    console.log('App: login: userData:', userData)
    this.setState({ logged: true, menuItem: getInitialMenuItem(), userData: userData })
  };
}

function getInitialMenuItem (): TopMenuItem {
  let menuItem: TopMenuItem = TopMenuItem.Login

  if (isReviewer()) {
    menuItem = TopMenuItem.Tool
  }
  return menuItem
}
